import { FC } from 'react'
import { Button } from 'antd'
import { RiArrowLeftLine } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'

import styles from './styles.module.scss'

const BroadcastHeader: FC = () => {
	const navigate = useNavigate()

	const handleBack = () => {
		if (window.history.state && window.history.state.idx > 0) {
			navigate(-1)
		} else {
			navigate('/broadcasts')
		}
	}

	return (
		<div className={styles.header}>
			<Button
				type='primary'
				icon={<RiArrowLeftLine />}
				onClick={() => handleBack()}
			>
				Back
			</Button>
		</div>
	)
}

export default BroadcastHeader
